'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = require('dom-helpers/style');

var _style2 = _interopRequireDefault(_style);

var _ModalManager2 = require('react-overlays/lib/ModalManager');

var _ModalManager3 = _interopRequireDefault(_ModalManager2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// needed for the modal manager class

var SpectrumModalManager = function (_ModalManager) {
  _inherits(SpectrumModalManager, _ModalManager);

  function SpectrumModalManager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SpectrumModalManager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SpectrumModalManager.__proto__ || Object.getPrototypeOf(SpectrumModalManager)).call.apply(_ref, [this].concat(args))), _this), _this.superAdd = _this.add, _this.superRemove = _this.remove, _this.add = function (modal, contaner, className) {
      _this.superAdd(modal, contaner, className);
      _this.bodyOverflow = document.body.style.overflow;
      (0, _style2.default)(document.body, { overflow: 'hidden' });
    }, _this.remove = function (modal, contaner, className) {
      _this.superRemove(modal, contaner, className);
      (0, _style2.default)(document.body, { overflow: _this.bodyOverflow });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  } // extending for the add and remove

  // For the sake of overriding add and remove methods, saving ModalManager's properties
  // This could be avoided if ModalManager had classMethods instead of arrow functions


  _createClass(SpectrumModalManager, [{
    key: 'addToModal',
    value: function addToModal(child) {
      var hideSiblingNodes = this.hideSiblingNodes;
      this.hideSiblingNodes = false;
      this.add(child, document.body);
      this.hideSiblingNodes = hideSiblingNodes;
    }
  }, {
    key: 'removeFromModal',
    value: function removeFromModal(child) {
      var hideSiblingNodes = this.hideSiblingNodes;
      this.hideSiblingNodes = false;
      this.remove(child);
      this.hideSiblingNodes = hideSiblingNodes;
    }
  }]);

  return SpectrumModalManager;
}(_ModalManager3.default);

exports.default = SpectrumModalManager;